import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";

export default function Layout() {
  const containers = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: containers.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require("../assets/images/mail.json"),
    });
  });
  return (
    <div className="container">
      <div className="layout__wrapper">
        <div className="layout">
          <div className="layout-bottom">
            <div className="containers img" ref={containers}></div>
          </div>
          <div className="title">
            <h1>Thank You</h1>
            <h1>Very Much For Reaching Out</h1>
          </div>
        </div>
      </div>
    </div>
  );
}
